'use client';

import React, { useState } from 'react';

import Image from 'next/image';

import CheckIcon from '@/assets/icons/check-gray.svg';
import AlertCircle from '@/assets/images/alert-circle.svg';
import EyeIcon from '@/assets/images/eye-icon.svg';
import EyeOffIcon from '@/assets/images/eye-off-icon.svg';
import TextInput from '@/components/V2/TextInput';

interface PasswordInputProps {
  name: string;
  label: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  className?: string;
  inputClassName?: string;
  isVerified?: boolean;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  error,
  className = '',
  inputClassName = '',
  isVerified = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const BUTTON_CLASSES = 'v2-absolute v2-right-3 v2-top-[11px] v2-cursor-pointer v2-bg-transparent v2-border-0 v2-p-0';

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`v2-w-full ${className}`}>
      <label
        htmlFor={name}
        className="v2-block v2-mb-[6px] v2-text-[#344054] v2-text-sm v2-font-sweet-sans-pro-medium v2-font-medium"
      >
        {label}
      </label>
      <TextInput
        type={showPassword ? 'text' : 'password'}
        name={name}
        placeholder={placeholder || label}
        inputClassName={`v2-font-sweet-sans-pro ${
          error
            ? '!v2-border-[#FDA29B] focus:!v2-border-[#FDA29B] focus:!v2-shadow-none'
            : isVerified
            ? '!v2-border-[#12B76A] focus:!v2-border-[#12B76A] focus:!v2-shadow-none !v2-bg-[#C5D1CC]'
            : ''
        } ${inputClassName}`}
        value={value}
        onChange={onChange}
        error={error}
        rightIconComponent={
          <div className="v2-flex v2-items-center v2-gap-2">
            {error && value && (
              <Image src={AlertCircle} alt="Error" className="v2-w-5 v2-h-5 v2-absolute v2-right-9 v2-top-[11px]" />
            )}
            {error && !value && (
              <Image src={AlertCircle} alt="Error" className="v2-w-5 v2-h-5 v2-absolute v2-right-3 v2-top-[11px]" />
            )}
            {isVerified && value && (
              <Image src={CheckIcon} alt="Verified" className="v2-w-5 v2-h-5 v2-absolute v2-right-3 v2-top-[11px]" />
            )}
            {value && !isVerified && (
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className={BUTTON_CLASSES}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <Image
                  src={showPassword ? EyeOffIcon : EyeIcon}
                  alt={showPassword ? 'Hide password' : 'Show password'}
                  className="v2-w-5 v2-h-5"
                />
              </button>
            )}
          </div>
        }
        messageClassName={error ? 'v2-text-[#D92D20]' : ''}
      />
    </div>
  );
};

export default PasswordInput;
